<template>
    
  <div class="grid" v-if="notaCredito">
    <div class="col">
      <div  class="card mb-0">
        <div class="flex justify-content-between mb-3">
          <div>
            <span class="block text-500 font-medium mb-1 title-detail">IMPORTO</span>
            <div class="text-900 font-medium text-xl">
              <div class="importo">{{notaCredito.totale_fattura.toFixed(2)}}
                <span class="pi pi-euro"></span>
              </div>
            </div>
          </div>
          <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
            <i class="pi pi-euro text-blue-500 text-xl"></i>
          </div>
        </div>
        <hr>
        <div class="grid">
          <div class="col-6">
            <p class="block text-500 font-medium mb-1 title-detail"> DATA EMISSIONE</p>
            <b>{{notaCredito.data_emissione}}</b>
          </div>
          <div class="col-6">
            <p class="block text-500 font-medium mb-1 title-detail">DATA SCADENZA</p>
            <b>{{notaCredito.data_scadenza}}</b>
          </div>
          <div class="col-6">
            <p class="block text-500 font-medium mb-1 title-detail">NUMERO FATTURA</p>
            <b>{{notaCredito.numero}}</b>
          </div> 
          <div v-if="typeNote == 'note-vendita'" class="col-6">
            <p class="block text-500 font-medium mb-1 title-detail">CLIENTE</p>
            <b>{{notaCredito.cliente}}</b>
          </div>
          <div v-if="typeNote == 'note-vendita'" class="col-6">
            <p class="block text-500 font-medium mb-1 title-detail">POD</p>
            <b>{{notaCredito.pod}}</b>
          </div>
          <div v-if="typeNote == 'note-acquisto'" class="col-6">
            <p class="block text-500 font-medium mb-1 title-detail">FORNITORE</p>
            <b>{{notaCredito.ragsoc}}</b>
          </div>
        </div>
      </div>
    </div>


    <Accordion class="mt-3 card col-12">
      <AccordionTab header="ASSOCIA"> 
        <div class="grid mt-1">
          
          <div class="col-12">
            <Dropdown v-model="selectedAssociate" :options="type_associates" optionLabel="name" optionValue="val" placeholder="Seleziona" class="inputfield w-full" />
          </div>
   
          <div class="col-12" v-if="typeNote == 'note-vendita'">
            <!-- fatture vendita -->
            <div  v-if="selectedAssociate == 'fatture-vendita'" style=" position:relative">
              <Fatture :detail="notaCredito" :type="selectedAssociate" @movement-regularized="goPrevNextDetail($event)" />
            </div>
          </div>

          <div class="col-12" v-if="typeNote == 'note-acquisto'">
            <!-- fatture acquisto -->
            <div v-if="selectedAssociate == 'fatture-acquisto'" style=" position:relative">
              <Fatture :detail="notaCredito" :type="selectedAssociate" @movement-regularized="goPrevNextDetail($event)" />
            </div>
          </div> 

        </div>
      </AccordionTab>
    </Accordion>

  </div>

  <div v-else class="card">
    <Skeleton class="mb-2"></Skeleton>
    <Skeleton width="100%" class="mb-2"></Skeleton>
    <Skeleton width="5rem" class="mb-2"></Skeleton>
    <Skeleton height="2rem" class="mb-2"></Skeleton>
    <Skeleton width="10rem" height="4rem"></Skeleton>
  </div>

  <!-- <div v-else> 
    <div  class="card mb-0">
      <div class="mb-4 flex justify-content-center">
        <div class="flex justify-content-center flex-column align-items-center">
          <div class="flex align-items-center justify-content-center bg-green-200 border-round mb-5" style="width:4.5rem;height:4.5rem">
            <i class="pi pi-check text-green-50 text-xl"></i>
          </div>
          Movimento regolarizzato
        </div>
      </div>
      <router-link to="/estratti-conto"> 
        <span class="pi pi-arrow-left mr-2"></span> Torna ad estratti conto
      </router-link>
    </div>
  </div> -->

</template> 

<script>

import { ref, getCurrentInstance, onMounted } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'
import {useRoute, useRouter} from 'vue-router';
import Fatture from '../unregularized/associa/Fatture.vue'


export default {

    components: {
        Fatture,
    },
    setup() {
  
      const route = useRoute()
      const router = useRouter()
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const service = new Service(self.$http, self.$eventBus)
      const typeNote = ref(route.params.typeNote)
      const idFattura = ref(route.params.id)
      const notaCredito = ref(null)
      const selectedAssociate = ref('')
      const type_associates = ref([])

      onMounted(() => {
        getData()
        populateTypeAssociate()
      })

      const populateTypeAssociate = () => {
        if (typeNote.value == 'note-vendita') {
          type_associates.value = [{
            name: 'Fatture Vendita',
            val:  'fatture-vendita',
          }]
          
        } else if(typeNote.value == 'note-acquisto') {
          type_associates.value = [{
            name: 'Fatture Acquisto',
            val:  'fatture-acquisto',
          }]
        }
      }

     
      const getData = () => {
        service.getNoteDetail(idFattura.value, typeNote.value).then((res) => {
          if (res.items.length) {
            notaCredito.value = res.items[0]
          } 
        })
      }


      const goPrevNextDetail = (evt) => {
        let idFattura = evt.id
        router.push({ path: `/estratti-conto/detail/prev-next/${idFattura}`})
      }


      return { 
        notaCredito, typeNote, type_associates, selectedAssociate, goPrevNextDetail
      }

    }
}
</script>

<style scoped>
.importo {
  font-size: 3.5rem;
  color: var(--blue-500);
}


.title-detail {
  font-size: 10px;
  letter-spacing: 2px;
}

</style>

